import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;
const LOCATOR_API_URL = API_URL + "/locator_service";

export const retrieveDropBoxes = async () => {
  return await axios.get(`${LOCATOR_API_URL}/retrieve_drop_boxes`);
};

export const retrieveServiceArea = async (data) => {
  return await axios.post(`${LOCATOR_API_URL}/retrieve_service_areas`, data);
};

export const searchBranches = async (data) => {
  return await axios.post(`${LOCATOR_API_URL}/search_branches`, data);
};
